export default function ImageModalController($uibModalInstance, url) {
  this.url = url;

  this.ok = () => {
    return $uibModalInstance.close(this.url);
  };
}
